module.exports = __webpack_public_path__ + "img/sync-video-eyeball@2x.2111a0cc.png";